// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormMasterData } from '~/utils/interface/masterData';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormMasterData> => {
  return yup.object().shape({
    name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
  });
};

export const defaultValuesEventTypeForm: IFormMasterData = {
  name: EMPTY_STRING,
};
